import { render, staticRenderFns } from "./bot.vue?vue&type=template&id=22a17d2e"
import script from "./bot.vue?vue&type=script&lang=js"
export * from "./bot.vue?vue&type=script&lang=js"
import style0 from "./bot.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/bot.vue
// module id = LKTB
// module chunks = 0